// extracted by mini-css-extract-plugin
export default {"floaterMob":"FloatNextButton_floaterMob__TAigC","floaterMobIcon":"FloatNextButton_floaterMobIcon__fyKVF","floaterMobLink":"FloatNextButton_floaterMobLink__+8-yy"};